import OrangeCheck from '@propertypal/shared/src/resources/icons/estate-agent-websites/small-orange-arrow-icon.svg';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { MidHeading, SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import {
  Container,
  Lists,
  Essential,
  Premium,
  ListTitle,
  ListItems,
  ListItem,
  PremiumSubtitle,
  CurvedLine,
  DevHeading,
  CurvedLineMob,
} from './TemplateWebsites.style';

const essential = [
  'Mobile Friendly',
  'Homepage, About Us & Contact Us Page',
  'Semantic Search & Autosuggestions',
  'Unlimited Search and Details Pages',
  'Photo Slideshow, Map & Street View',
  'Property Video, 3D, Audio & Virtual Tour Uploads',
  'Printer Friendly Property Details Pages',
  'Document Hosting (i.e Rental Application Forms)',
  'Standard SEO Package',
  'Free SSL (Protects Your Users Privacy)',
  'Google Analytics Integration',
  'Integration With Management Software',
];

const premium = [
  'User Section, Favourites, Saved Searches & Alerts',
  'Homepage Featured Properties',
  'Testimonials',
  'News / Blog / Newsletter',
  'Draw a Search Technology',
  'Large Image Slideshow',
  'Mortgage & Stamp Duty Calculator',
  'Custom Map Colours',
  'Premium Design',
  'Featured Developments',
];

const devLeft = [
  `Mobile Friendly`,
  `Homepage, About Us & Contact Us Page`,
  `Semantic Search & Autosuggestions`,
  `Unlimited Search and Details Pages`,
  `Photo Slideshow, Map & Street View`,
  `Property Video, 3D, Audio & Virtual Tour Uploads`,
  `Printer Friendly Property Details Pages`,
  `Document Hosting (i.e Rental Application Forms)`,
  `Standard SEO Package`,
  `Free SSL (Protects Your Users Privacy)`,
  `Google Analytics Integration`,
];

const devRight = [
  `Integration With Management Software`,
  `User Section, Favourites, Saved Searches & Alerts`,
  `Homepage Featured Properties`,
  `Testimonials`,
  `News / Blog / Newsletter`,
  `Draw a Search Technology`,
  `Large Image Slideshow`,
  `Mortgage & Stamp Duty Calculator`,
  `Custom Map Colours`,
  `Premium Design`,
  `Featured Developments`,
];

interface TemplateWebsitesProps {
  dev?: boolean;
}

const TemplateWebsites: React.FC<TemplateWebsitesProps> = ({ dev }) => {
  return (
    <Container>
      <PageWrapper>
        <SubHeading fontSize={60} mb={25} align="center">
          {dev ? `Website Options` : `Template Websites`}
        </SubHeading>
        {!dev && (
          <Text align="center" fontSize={!dev ? 24 : undefined}>
            We offer two different template websites to cater for all budgets
          </Text>
        )}
        {dev && (
          <DevHeading align="center" fontSize={40} mt={50}>
            Included with our templates
          </DevHeading>
        )}
        <Lists dev={dev}>
          <Essential dev={dev}>
            {!dev && (
              <ListTitle data-testid="essential-heading">
                <MidHeading>Essential</MidHeading>
              </ListTitle>
            )}
            <ListItems>
              {(dev ? devLeft : essential).map((item) => (
                <ListItem key={item}>
                  <OrangeCheck />
                  <span>{item}</span>
                </ListItem>
              ))}
            </ListItems>
          </Essential>
          <Premium>
            {!dev && (
              <>
                <ListTitle data-testid="premium-heading">
                  <MidHeading>Premium</MidHeading>
                </ListTitle>
                <PremiumSubtitle>
                  <span>
                    Everything from our Essential package <strong>PLUS…</strong>
                  </span>
                  <CurvedLine />
                  <CurvedLineMob />
                </PremiumSubtitle>
              </>
            )}
            {(dev ? devRight : premium).map((item) => (
              <ListItem key={item}>
                <OrangeCheck />
                <span>{item}</span>
              </ListItem>
            ))}
          </Premium>
        </Lists>
      </PageWrapper>
    </Container>
  );
};

export default TemplateWebsites;
